import React, { FC } from 'react';

import { subYears } from 'date-fns';
import { Grid, Paper, Stack, Typography } from '@mui/material';
import Http from '@/services/http';
import Loading from '@/components/loading';

import { GeneralItem } from './general-info-item';
import { DashboardFilter } from '.';

type GeneralInfo = {
  auditedUsersCount: number;
  rifsDoneCount: number;
  processesCount: number;
  percentageOfWeaknessesIdentified: number;
  percentageOfUsersAudited: number;
  percentageOfProcessesAudited: number;
};

interface IGeneralInfoSectionProps {
  filter?: DashboardFilter | null;
}

const GeneralInfoSection: FC<IGeneralInfoSectionProps> = ({ filter }) => {
  const [loading, setLoading] = React.useState(false);
  const [generalInfo, setGeneralInfo] = React.useState<GeneralInfo | null>(
    null
  );

  const defaultStartDate = React.useMemo(() => subYears(new Date(), 1), []);
  const defaultEndDate = React.useMemo(() => new Date(), []);

  const fetchGeneralInfo = React.useCallback(async () => {
    setLoading(true);
    const parsedFilter = {
      base: filter?.base?.id || '',
      aircraftModel: filter?.aircraftModel?.id || '',
      startDate:
        filter?.startDate?.toISOString() || defaultStartDate.toISOString(),
      endDate: filter?.endDate?.toISOString() || defaultEndDate.toISOString(),
      type: filter?.type || '',
    };
    const queryParams = filter
      ? new URLSearchParams(parsedFilter).toString()
      : '';

    const { data } = await Http.get(`dashboard/general-info?${queryParams}`);
    setGeneralInfo(data);
    setLoading(false);
  }, [filter, defaultStartDate, defaultEndDate]);

  React.useEffect(() => {
    fetchGeneralInfo();
  }, [fetchGeneralInfo]);

  return (
    <Paper sx={{ width: '100%' }}>
      <Grid
        container
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(480px, auto))',
        }}
        sx={{ mt: 2, gap: 2, width: '100%', ml: 0 }}
      >
        <Loading backgroundColor="transparent" loading={loading} />
      </Grid>
      <Stack direction="column" p={2} pb={0}>
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: '1.5rem',
          }}
        >
          Dados gerais
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="stretch" p={2} spacing={2}>
        <GeneralItem
          count={generalInfo?.rifsDoneCount}
          label="Auditorias realizadas"
        />
        <GeneralItem count={generalInfo?.auditedUsersCount} label="Auditados" />
        <GeneralItem count={generalInfo?.processesCount} label="Processos" />
        <GeneralItem
          count={generalInfo?.percentageOfWeaknessesIdentified?.toFixed(2)}
          label="% Fraquezas"
        />
        <GeneralItem
          count={generalInfo?.percentageOfUsersAudited?.toFixed(2)}
          label="% Auditados"
        />
        <GeneralItem
          count={generalInfo?.percentageOfProcessesAudited?.toFixed(2)}
          label="% Processos"
        />
      </Stack>
    </Paper>
  );
};

export default GeneralInfoSection;
